module.exports = __webpack_public_path__ + "img/Straight-through-Process(2).ef1584c1.png";